<!--
  详情页
  lovi 2020-06-02
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="
        flag == 2
          ? $t('common.withdrawalDetail')
          : flag == 3
          ? $t('common.transferDetail')
          : $t('common.rechargeDetail')
      "
      left-arrow
      @click-left="_back"
    />

    <div class="scroll-wrapper">
      <scroll>
        <div class="detail-wrap" v-if="detail.list">
          <div class="info">
            <div>
              <img
                class="icon"
                :src="
                  detail.icon
                    ? httpUrl + detail.icon
                    : require('@/assets/images/public/logo_icon@2x.png')
                "
              />
              <div class="">
                <h3>{{ detail.label }}</h3>
                <p class="text-blue">{{ detail.state_label }}</p>
              </div>
            </div>
            <div class="money">
              {{
                detail.money_type == 1
                  ? "+"
                  : detail.money_type == 2
                  ? "-"
                  : ""
              }}{{ detail.money }}
            </div>
          </div>

          <van-cell
            v-for="(item, index) in detail.list"
            :key="index"
            :title="item.label"
            :value="item.value === '' ? $t('common.nothing') : item.value"
            @click="toSubOrder(item)"
            :is-link="item.is_click ? true : false"
          />
        </div>

        <div class="button-wrap" v-if="detail.list">
          <van-button
            v-if="routeData.button"
            block
            type="primary"
            @click="_back"
          >
            {{ $t("common.rechargeAgain") }}
          </van-button>
          <van-button
            v-else-if="
              (detail.pay_type == 1 ||detail.pay_type == 2||detail.pay_type == 10||
                detail.pay_type == 5 ||
                detail.pay_type == 7 ||
                detail.pay_type == 8) &&
                detail.is_pending_payment
            "
            round
            type="primary"
            block
            :loading="btnLoading"
            @click="payment"
          >
            {{ $t("common.immediatelyPay") }}
          </van-button>
        </div>
      </scroll>
    </div>

    <transition name="slide">
      <sub-order
        v-if="subOrderFlag"
        :subOrderFlag.sync="subOrderFlag"
        :data="subOrderData"
      />
    </transition>
  </div>
</template>

<script>
import SubOrder from "./subOrder";
export default {
  name: "detail",
  components: {
    SubOrder
  },
  data() {
    return {
      // 1充值 2提现 3转账 5话费 6流量 20批量话费 21批量流量 8水费 9电费 10网费 11Grab 12银行 13贷款 14电子钱包 15保险 16房地产 17宿务航空 18政府 19支付网关
      flag: 0,
      order_id: "",
      is_batch: "",
      routeData: {},
      detail: {}, // 详情数据
      btnLoading: false,
      subOrderData: {},
      timer: '',
      subOrderFlag: false,
      isReturn: ""
    };
  },
  created() {
    let vm = this;
    vm.flag = vm.$route.query.flag;
    vm.order_id = vm.$route.query.order_id;
    vm.is_batch = vm.$route.query.is_batch;
    vm.isReturn = vm.$route.query.isReturn;
    if (vm.order_id) {
      vm._getDetail();
    } else {
      // 返回上一层
      this._back();
    }
    vm.routeData = vm.$route.params;
    console.log("routeData", vm.routeData);
    if (vm.routeData.tips) {
      vm.$dialog
        .confirm({
          message: vm.$t("recharge.eTips"),
          showCancelButton: false,
          confirmButtonText: vm.$t("common.confirm")
        })
        .then(() => {
          // 验证
          console.log("确认");
        });
    }
  },
  mounted() {
    this.timer = setInterval(this.get, 60*1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  computed: {},
  methods: {
    _getDetail() {
      // 订单详情
      let vm = this;
      let params = {};
      params.type = vm.flag;
      params.order_id = vm.order_id;
      params.is_batch = vm.is_batch;
      vm.$post("/app/recharge/rechargeRecordDetails", params, {
        loading: true
      }).then(res => {
        console.log("rechargeRecordDetails", res);
        vm.detail = res;
      });
    },
    toSubOrder(data) {
      // 获取子订单参数
      let vm = this;
      if (data.is_click) {
        vm.subOrderFlag = true;
        vm.subOrderData.type = vm.detail.type;
        vm.subOrderData.status = data.status;
        vm.subOrderData.order_id = vm.order_id;
        vm.subOrderData.title = data.label;
      }
    },
    payment() {
      // 立即支付
      let vm = this;
      let routeData = {};
      let params = {};
      if (vm.detail.pay_type == 5) {
        // 5.微信扫码支付
        params.payment_id = vm.detail.payment_id;
        params.type = vm.detail.type;
        params.order_id = vm.order_id;
        vm.btnLoading = true;
        vm.$post("/app/pay/toPayment", params, { alert: true }).then(res => {
          console.log("toPayment", res);
          vm.btnLoading = false;
          if (res.code == 0) {
            // this.$store.dispatch("DELETE_INCLUDE", "record");
            routeData = res.data;
            routeData.money = vm.detail.money;
            vm.$router.replace({
              path: "/payCode",
              name: "payCode",
              query: { flag: vm.flag, payType: vm.detail.pay_type },
              params: routeData
            });
          } else {
            vm.$toast(res.msg);
          }
        });
      }
      if (vm.detail.pay_type == 7 || vm.detail.pay_type == 8) {
        // 7.线下现金、8.线下银行卡
        params.type = vm.detail.pay_type == 7 ? "2" : "1";
        params.order_id = vm.order_id;
        vm.$post("/app/pay/bankTopayment", params, { loading: true }).then(
          res => {
            console.log("bankTopayment", res);
            routeData.type = vm.detail.pay_type;
            routeData.title = vm.detail.pay_label;
            routeData.money = res.money;
            routeData.additional_code = res.additional_code;
            routeData.bank = res.list[0];
            vm.$router.push({
              path: "/rechargeOffline",
              name: "rechargeOffline",
              params: routeData
            });
          }
        );
      }

      if (vm.detail.pay_type == 2||vm.detail.pay_type == 10) {
        //支付宝app付
        /* eslint-disable */
        params.payment_id = vm.detail.payment_id;
        params.type = vm.detail.type;
        params.order_id = vm.order_id;
        vm.$post("/app/pay/toPayment", params, { loading: true }).then(res => {
          if(vm.detail.pay_type == 10)
          {
            window.location.href=res.return_charge.content;
            routeData.button = true;
            vm.$router.push({
              path: "/detail",
              name: "detail",
              query: {
                flag: vm.flag,
                order_id: res.order_id
              },
              params: routeData
            });

          }
          else {
            jsBridge.aliPay({
              orderString: res.return_charge.query
            }, function(succ, text) {
              if (succ) {
                alert("支付成功");
                routeData.button = true;
                vm.$router.push({
                  path: "/detail",
                  name: "detail",
                  query: {
                    flag: vm.flag,
                    order_id: res.order_id
                  },
                  params: routeData
                });
              } else {
                alert("支付失败或取消了支付");
              }
            });
          }
        })

      }
      if (vm.detail.pay_type == 1) {
        params.payment_id = vm.detail.payment_id;
        params.type = vm.detail.type;
        params.order_id = vm.order_id;
        vm.$post("/app/pay/toPayment", params, { loading: true }).then(res => {
        //微信app付
        /* eslint-disable */
          if(vm.enter=="wechat")
          {
            window.location.href=res.return_charge.content;
            routeData.button = true;
            vm.$router.push({
              path: "/detail",
              name: "detail",
              query: {
                flag: vm.flag,
                order_id: res.order_id
              },
              params: routeData
            });
          }
          else {
            jsBridge.wxPay({
              appid: res.return_charge.appid,
              partnerid: res.return_charge.partnerid,
              prepayid: res.return_charge.prepayid,
              package: res.return_charge.package,
              noncestr: res.return_charge.noncestr,
              timestamp: res.return_charge.timestamp,
              sign: res.return_charge.sign
            }, function(succ, text) {
              if (succ) {
                routeData.button = true;
                vm.$router.push({
                  path: "/detail",
                  name: "detail",
                  query: {
                    flag: vm.flag,
                    order_id: res.order_id
                  },
                  params: routeData
                });
              } else {

              }
            })
          }
        });
      }
    },
    get() {
      //location.reload();
    }

  },
  watch: {}
};
</script>

<style lang="less" scoped>
.detail-wrap {
  .info {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 1;
    > div {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .icon {
        margin-right: 10px;
        width: 48px;
        height: 48px;
      }
      > div {
        h3 {
          font-size: 16px;
          font-weight: 500;
        }
        p {
          margin-top: 5px;
          font-size: 12px;
        }
      }
    }

    .money {
      font-size: 18px;
      font-weight: 500;
    }
  }
}

/deep/.van-cell__title {
  flex: initial;
}
</style>
